<template>
  <nx-menu-dropdown
    :text="$t(`message.list.views.${value.text}`)"
    :icon="value.icon"
  >
    <template #content>
      <v-list>
        <v-list-tile
          v-for="(view, index) in views"
          :key="index"
          @click="$emit('input', view)"
        >
          <v-list-tile-action>
            <v-icon>{{ view.icon }}</v-icon>
          </v-list-tile-action>
          <v-list-tile-content>
            <v-list-tile-title :class="{ 'nx-text--level-1': true, 'accent--text' : view.value === value.value }">
              {{ $t(`message.list.views.${view.text}`) }}
            </v-list-tile-title>
          </v-list-tile-content>
        </v-list-tile>
      </v-list>
    </template>
  </nx-menu-dropdown>
</template>

<script>
import NxMenuDropdown from '@/components/menu/Dropdown';

export default {
  components: {
    NxMenuDropdown,
  },
  props: {
    views: {
      type: Array,
      default: () => ([]),
    },
    value: {
      type: Object,
      default: () => ({}),
    },
  },
};
</script>
